import { useTranslation } from 'react-i18next';

type TppHistoryEmptyStateProps = {
  emptyCanCheckout?: boolean;
  emptyCanCharge?: boolean;
  /** 無効カード（貸出不可）。再有効化を案内 */
  emptyInactive?: boolean;
};

/** 履歴ゼロの文面のみ。貸出・チャージ操作はカード行に一本化（重複 CTA 禁止） */
export default function TppHistoryEmptyState({
  emptyCanCheckout = false,
  emptyCanCharge = false,
  emptyInactive = false,
}: TppHistoryEmptyStateProps) {
  const { t } = useTranslation();

  const message = emptyInactive
    ? t('tpp.history_empty_inactive')
    : emptyCanCharge && !emptyCanCheckout
      ? t('tpp.history_empty_charge_first')
      : t('tpp.history_empty_fresh');

  return (
    <p className="mb-0 small text-muted text-center mx-auto" style={{ maxWidth: '28rem' }}>
      {message}
    </p>
  );
}
